import React from 'react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', id: 'hero' },
    { name: 'About Us', id: 'about' },
    { name: 'Our Vision', id: 'vision' },
    { name: 'Services', id: 'services' },
    { name: 'Team', id: 'team' },
    { name: 'Contact Us', id: 'contact' }
  ];

  const services = [
    'Credit Verification',
    'Address Verification',
    'Employment Verification',
    'Background Checks',
    'Due Diligence',
    'Premarital Verification'
  ];

  const branches = [
    { state: 'Andhra Pradesh', cities: 'Kurnool (HQ), Tirupati, Vijayawada, Visakhapatnam' },
    { state: 'Telangana', cities: 'Hyderabad, Warangal, Karimnagar' },
    { state: 'Karnataka', cities: 'Bangalore, Hubli, Mysore' },
    { state: 'Tamil Nadu', cities: 'Chennai, Coimbatore, Madurai' }
  ];

  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 text-white overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-cyan-500/5 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '4s' }}></div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M30 30m-15 0a15 15 0 1 1 30 0a15 15 0 1 1 -30 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }}></div>

      <div className="relative z-10">
        {/* Main Footer Content */}
  <div className="container py-16">
          {/* Adjusted grid: removed unused 4th column (branches section commented out) to avoid empty right space */}
          <div className="grid md:grid-cols-3 gap-10 lg:gap-14 xl:gap-16">
            {/* Company Info */}
            <div className="lg:col-span-1">
              {/* Logo */}
              <div className="flex items-center space-x-3 mb-8">
                <div className="relative">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 rounded-xl shadow-xl flex items-center justify-center">
                    <div className="text-center">
                      <i className="fas fa-shield-alt text-white text-xl mb-1"></i>
                      <div className="text-white font-bold text-xs">RLDS</div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col">
                  <div className="font-black text-3xl tracking-wider text-white">RLDS Pvt Ltd</div>
                  <div className="text-sm font-semibold tracking-wide text-blue-200">Due Diligence Services</div>
                </div>
              </div>

              <p className="text-blue-100 mb-8 leading-relaxed">
                <strong>RAGHUVEER REDDY LINGAMPALI DUE DILIGENCE SERVICES PRIVATE Ltd</strong> - 
                Professional verification and investigation services across South India since 2019.
              </p>

              {/* Contact Info */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="fas fa-map-marker-alt text-blue-400"></i>
                  <span className="text-blue-100">Kurnool, Andhra Pradesh (HQ)</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="fas fa-phone text-green-400"></i>
                  <span className="text-blue-100">+91 7901234566</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="fas fa-envelope text-purple-400"></i>
                  <span className="text-blue-100">info@rldspvt.com</span>
                </div>
              </div>

              {/* Certifications */}
              <div className="flex flex-wrap gap-3">
                <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 py-2 rounded-full">
                  <i className="fas fa-certificate text-blue-400"></i>
                  <span className="text-xs font-medium text-blue-100">SBI Empaneled</span>
                </div>
                <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 py-2 rounded-full">
                  <i className="fas fa-award text-green-400"></i>
                  <span className="text-xs font-medium text-blue-100">Bank Certified</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="ml-24">
              <h3 className="text-xl font-bold text-white mb-8 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full"></div>
              </h3>
              <ul className="space-y-4">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <button 
                      onClick={() => scrollToSection(link.id)}
                      className="text-blue-100 hover:text-white transition-colors duration-300 hover:translate-x-2 transform inline-block"
                    >
                      <i className="fas fa-angle-right mr-2 text-blue-400"></i>
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-xl font-bold text-white mb-8 relative">
                Our Services
                <div className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-green-400 to-blue-400 rounded-full"></div>
              </h3>
              <ul className="space-y-4">
                {services.map((service, index) => (
                  <li key={index}>
                    <button 
                      onClick={() => scrollToSection('services')}
                      className="text-blue-100 hover:text-white transition-colors duration-300 hover:translate-x-2 transform inline-block"
                    >
                      <i className="fas fa-check-circle mr-2 text-green-400"></i>
                      {service}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Branches */}
            {/* <div>
              <h3 className="text-xl font-bold text-white mb-8 relative">
                Our Branches
                <div className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full"></div>
              </h3>
              <div className="space-y-4">
                {branches.map((branch, index) => (
                  <div key={index} className="bg-white/5 backdrop-blur-sm rounded-lg p-4">
                    <h4 className="font-semibold text-white mb-2">{branch.state}</h4>
                    <p className="text-blue-100 text-sm">{branch.cities}</p>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>

        {/* Newsletter Section
        <div className="border-t border-white/10">
          <div className="container py-12">
            <div className="max-w-4xl mx-auto text-center">
              <h3 className="text-2xl font-bold text-white mb-4">Stay Connected for Professional Updates</h3>
              <p className="text-blue-100 mb-8">Get the latest updates on our services and professional verification solutions.</p>
              <div className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
                <input 
                  type="email" 
                  placeholder="Enter your email address" 
                  className="flex-1 px-6 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-blue-200 focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all"
                />
                <button className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-4 rounded-xl font-semibold hover:from-blue-600 hover:to-purple-600 transition-all duration-300 transform hover:scale-105">
                  Subscribe
                  <i className="fas fa-arrow-right ml-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div> */}

        {/* Bottom Footer */}
        <div className="border-t border-white/10">
          <div className="container py-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-blue-200 text-sm mb-4 md:mb-0">
                © {currentYear} RAGHUVEER REDDY LINGAMPALI DETECTIVE SERVICES PRIVATE Ltd (RLDS Pvt Ltd). All rights reserved.
              </div>
              <div className="flex items-center space-x-8">
                <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </a>
                <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors">
                  Terms of Service
                </a>
                <div className="flex items-center space-x-4">
                  <a href="#" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors">
                    <i className="fab fa-linkedin text-blue-300"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors">
                    <i className="fab fa-twitter text-blue-300"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors">
                    <i className="fab fa-facebook text-blue-300"></i>
                  </a>
                </div>
                <button 
                  onClick={scrollToTop}
                  className="group w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center hover:from-blue-600 hover:to-purple-600 transition-all duration-300 transform hover:scale-110 shadow-lg"
                >
                  <i className="fas fa-arrow-up group-hover:-translate-y-1 transition-transform"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;